export const TIER_ORDER = { tracker: 0, regen_plus: 1, regen_method: 2 };
export const TIER_LABEL = { tracker: 'YourReGen Free', regen_plus: 'YourReGen+', regen_method: 'YourReGen Protocol' };

export function tierRank(tier) {
  return TIER_ORDER[tier || 'tracker'] ?? 0;
}
export function hasTier(userTier, needed) {
  return tierRank(userTier) >= tierRank(needed);
}
